module.exports = __webpack_public_path__ + "img/birthday-2013.ffdcbd6b.jpg";